<div #containerRef id="slick-file-list_{{uuid}}" class="slick-file-list">
	<slick-file-list-item *ngFor="let file of files; let idx = index"
						  [file]="file"
						  [allowDelete]="allowDelete"
						  [showPhotoGallery]="showPhotoGallery"
						  [showCheckbox]="showCheckboxes"
						  [thumbnailSize]="thumbnailSize"
						  [allowTitleEditing]="allowTitleEditing"
						  [confirmDelete]="confirmDelete"
						  (checkChanged)="onCheckChanged($event, idx)"
						  (fileClicked)="fileClicked($event, idx)"
						  (fileChange)="onFileChange($event, idx)"
						  (fileDelete)="onFileDelete($event, idx)"></slick-file-list-item>
</div>

<slick-photo-gallery #photoGalleryRef *ngIf="showPhotoGallery === true" [files]="files"></slick-photo-gallery>


<slick-dialog #videoPlayerDialogRef header="Video" cssClass="slick-file-list-video-dialog" [width]="videoDialogWidth" [height]="videoDialogHeight" [top]="videoDialogTop">
	<video [src]="videoSafeUrl"
		   controls
		   playsinline
		   autoplay
		   preload="metadata"
		   style="height: 70vh; width: auto; max-width: 100%; object-fit: contain; display: block; margin: 0 auto;">
	</video>
</slick-dialog>